var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-toggle-list__container" }, [
    _c("div", { staticClass: "c-toggle-list" }, [
      _c("div", { staticClass: "c-toggle-list__header" }, [
        _c("div", { staticClass: "c-toggle-list__header-content" }, [
          _vm.title
            ? _c("h2", { staticClass: "c-toggle-list__heading" }, [
                _vm._v(_vm._s(_vm.title))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.description
            ? _c("p", { staticClass: "c-toggle-list__description" }, [
                _vm._v("\n          " + _vm._s(_vm.description) + "\n        ")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.toggle
          ? _c(
              "button",
              {
                staticClass: "c-toggle-list__button",
                attrs: {
                  "aria-expanded": _vm.collapse ? "true" : "false",
                  "aria-controls": "mapLayers",
                  "aria-label": "Map layers"
                },
                on: { click: _vm.dropdown }
              },
              [
                _vm.collapse
                  ? _c(
                      "svg",
                      {
                        staticClass: "c-toggle-list__icon",
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#arrow-up"
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.collapse
                  ? _c(
                      "svg",
                      {
                        staticClass: "c-toggle-list__icon",
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#arrow-down"
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm.layers
      ? _c(
          "div",
          {
            staticClass: "c-toggle-list__panels",
            attrs: { id: "mapLayers", inert: _vm.collapse ? null : "inert" }
          },
          [
            _c(
              "div",
              {
                staticClass: "c-toggle-list__panels-container",
                class: _vm.collapse
                  ? "c-toggle-list__panels-container--is-visible"
                  : "c-toggle-list__panels-container--is-hidden"
              },
              [
                _vm._l(_vm.getSingleLayers, function(layer) {
                  return _c(
                    "div",
                    { key: layer.index },
                    [
                      layer.layerName
                        ? _c("MapTogglePanel", {
                            attrs: {
                              configurable: layer.configurable,
                              title: layer.layerName,
                              refId: layer.layerCode,
                              state: layer.selected,
                              icon: layer.icon
                            },
                            on: {
                              onToggleChecked: _vm.onToggleLayerChecked,
                              onToggleDisabled: _vm.onToggleLayerDisabled
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.getGroups, function(layer) {
                  return _c(
                    "div",
                    { key: layer.index, staticClass: "c-toggle-list__group" },
                    [
                      layer.groupName
                        ? _c(
                            "button",
                            {
                              staticClass: "c-toggle-list__link",
                              attrs: {
                                "aria-expanded": layer.expanded
                                  ? "true"
                                  : "false",
                                "aria-label": layer.groupName + " group",
                                "aria-controls": layer.groupName.replaceAll(
                                  " ",
                                  "-"
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onToggleGroup(layer.groupCode)
                                }
                              }
                            },
                            [
                              _c(
                                "h4",
                                { staticClass: "c-toggle-list__link-title" },
                                [_vm._v(_vm._s(layer.groupName))]
                              ),
                              _vm._v(" "),
                              layer.expanded
                                ? _c(
                                    "svg",
                                    {
                                      staticClass: "c-toggle-list__link-icon",
                                      attrs: {
                                        "aria-hidden": "true",
                                        focusable: "false"
                                      }
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xmlns:xlink":
                                            "http://www.w3.org/1999/xlink",
                                          "xlink:href": "#arrow-up"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !layer.expanded
                                ? _c(
                                    "svg",
                                    {
                                      staticClass: "c-toggle-list__link-icon",
                                      attrs: {
                                        "aria-hidden": "true",
                                        focusable: "false"
                                      }
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xmlns:xlink":
                                            "http://www.w3.org/1999/xlink",
                                          "xlink:href": "#arrow-down"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      layer.expanded
                        ? _c(
                            "div",
                            {
                              attrs: {
                                id: layer.groupName.replaceAll(" ", "-")
                              }
                            },
                            _vm._l(layer.layerConfigurations, function(layer) {
                              return _c("MapTogglePanel", {
                                key: layer.index,
                                attrs: {
                                  configurable: layer.configurable,
                                  title: layer.layerName,
                                  refId: layer.layerCode,
                                  state: layer.selected,
                                  icon: layer.icon
                                },
                                on: {
                                  onToggleChecked: _vm.onToggleLayerChecked,
                                  onToggleDisabled: _vm.onToggleLayerDisabled
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ]
                  )
                })
              ],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12092ffe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12092ffe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/layered-map/MapToggleList.vue
// module id = 663
// module chunks = 0